export default __webpack_public_path__ + "static/media/anıtkabir.8686a1d9.gif";